import script from "./DefinitionFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DefinitionFormModal.vue?vue&type=script&setup=true&lang=js"

import "./DefinitionFormModal.vue?vue&type=style&index=0&id=0521e51c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0521e51c"]])

export default __exports__